export default __webpack_public_path__ + "assets/images/d617939ce5b36ff9df27c902053f3874.png";